import type { FormDefinition, FormListRow } from "@omnabase/shared";
import { useFetch } from "./useFetch";

/** The form builder, round one: the workspace's forms as the screens read them (Settings › Forms and the builder). */
export const formsUrl = (slug: string) => `/api/v1/w/${encodeURIComponent(slug)}/forms`;
export const formUrl = (slug: string, id: string) => `${formsUrl(slug)}/${encodeURIComponent(id)}`;
export const useForms = (slug: string) => useFetch<FormListRow[]>(formsUrl(slug));
export const useFormDefinition = (slug: string, id: string) => useFetch<FormDefinition>(formUrl(slug, id));
